// packages/ui-kit/src/health/elderly-theme.ts
// ECharts 适老化主题 — 大字体/高对比度/简洁轴线 (NF-UX-01 / OLD-01)
// 规格: ADR-0013 / SPEC §6 ui-kit/health
// 各端可通过 echarts.init(dom, 'hssna-elderly') 应用本主题

/**
 * 适老化主题配置
 * - 基础字号 24px (PRD OLD-01 / NF-UX-01)
 * - 高对比度: 黑字白底, 简洁轴线
 * - grid containLabel 防止标签截断
 */
export const elderlyTheme = {
  textStyle: {
    fontSize: 24,
    color: '#000000',
    fontFamily: "system-ui, -apple-system, 'Segoe UI', sans-serif",
  },
  title: {
    textStyle: {
      fontSize: 28,
      color: '#000000',
      fontWeight: 'bold',
    },
    subtextStyle: {
      fontSize: 22,
      color: '#333333',
    },
  },
  legend: {
    textStyle: {
      fontSize: 22,
      color: '#000000',
    },
    itemWidth: 24,
    itemHeight: 16,
  },
  axisLabel: {
    fontSize: 22,
    color: '#000000',
  },
  axisLine: {
    lineStyle: {
      color: '#333333',
      width: 2,
    },
  },
  splitLine: {
    lineStyle: {
      color: '#cccccc',
      width: 1,
    },
  },
  tooltip: {
    textStyle: {
      fontSize: 22,
      color: '#000000',
    },
    backgroundColor: '#FFFFFF',
    borderColor: '#333333',
    borderWidth: 2,
  },
  grid: {
    containLabel: true,
    left: 24,
    right: 24,
    top: 32,
    bottom: 32,
  },
  categoryAxis: {
    axisLabel: {
      fontSize: 22,
      color: '#000000',
    },
    axisLine: {
      lineStyle: {
        color: '#333333',
        width: 2,
      },
    },
  },
  valueAxis: {
    axisLabel: {
      fontSize: 22,
      color: '#000000',
    },
    axisLine: {
      lineStyle: {
        color: '#333333',
        width: 2,
      },
    },
  },
} as const;

/** 适老化主题名称 */
export const ELDERLY_THEME_KEY = 'hssna-elderly';

/**
 * 检测当前文档是否启用了适老化主题 (html.theme-elderly)
 * 在 SSR / 非 DOM 环境返回 false
 */
export function detectElderlyTheme(): boolean {
  if (typeof document === 'undefined' || !document.documentElement) {
    return false;
  }
  return document.documentElement.classList.contains('theme-elderly');
}
